import { Avatar, Box, Link, Stack, Typography } from "@mui/material"
import { Trans, useTranslation } from "react-i18next"

import { designerLink } from "../../../../utils"

interface Props {
	name: string
	avatar: string
}

const COUNTER_WIDTH = "25"

export const Description = ({ name, avatar }: Props) => {
	const { t } = useTranslation("vote")
	const items = t("banner.items", { returnObjects: true })

	return (
		<Stack
			mb={{ lg: 0, xs: 3.75 }}
			mr={{ lg: 7, xs: 0 }}
			direction={{ lg: "row", xs: "column" }}
		>
			<Avatar
				src={avatar}
				alt={t("banner.avatar", { name })}
				sx={{
					width: 110,
					height: 110,
					mb: 3.75,
					mx: "auto",
					mr: { lg: 2.5, xs: "auto" },
				}}
			/>
			<Box>
				<Typography
					variant='h5'
					component='h3'
					mb={3.75}
					mt={{ lg: 2.4, xs: 0 }}
				>
					<Trans ns='vote' i18nKey='banner.title' values={{ name }}>
						<Link href={designerLink(name)}>
							<p />
						</Link>
					</Trans>
				</Typography>
				<Typography
					variant='h6'
					component='p'
					fontWeight='bold'
					mb={3.75}
				>
					{t("banner.subtitle")}
				</Typography>
				<Stack pl={`${COUNTER_WIDTH}px`} mb={7.5}>
					{items.map((item, idx) => (
						<Typography
							key={idx}
							variant='body2'
							display='flex'
							flexDirection='row'
							ml={`-${COUNTER_WIDTH}px`}
							sx={{
								"&:not(:last-child)": {
									mb: 2,
								},
								"&:before": {
									content: `"${idx + 1}."`,
									width: `${COUNTER_WIDTH}px`,
									flexShrink: 0,
								},
							}}
						>
							{item}
						</Typography>
					))}
				</Stack>
			</Box>
		</Stack>
	)
}
